// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"PageButton_buttonBox__DJn27","smallW":"PageButton_smallW__He5De","smallG":"PageButton_smallG__1LCJ1"};